import { Card, Col, Row } from 'antd';
import { UIImage } from '../../common/image';
import { officeDevice, offlineDevice } from '../../../assets/images';
import './style.css'

export const DeviceCard = (props: any) => {

    const { device, statusdevice } = props
    const macKey = (val: any) => String(val || '').replace(/[:-]/g, '').toUpperCase();
    const deviceKey = macKey(device?.mac);
    const Obj: any = statusdevice?.find((status: any) => macKey(status?.deviceMac) === deviceKey)
    const deviceStatusChange = () => {
        // Use the same logic as activity logs - check status directly from the status query result
        // This is more accurate than checking device?.status which may be stale
        const status = Obj?.status?.toLowerCase()?.trim();
        
        // Explicitly check for offline/disconnected statuses - show "Offline" in UI
        const isOffline = status === 'disconnected' || 
                         status === 'offline' ||
                         status === 'unreachable' ||
                         status === 'inactive' ||
                         Obj?.status === 'disconnected' || 
                         Obj?.status === 'offline';
        
        // Check for online statuses
        const isOnline = !isOffline && (
            status === 'connected' || 
            status === 'running' ||
            status === 'active-running' ||
            status === 'active' ||
            Obj?.status === 'connected' || 
            Obj?.status === 'running'
        );
        
        if (isOnline) {
            return (
                <><Col span={24} className="card-img" data-testid="imagee-id">
                    <UIImage src={officeDevice} alt="officedevice" height="85px" width="85px" />
                </Col>
                    <Col span={24} className='onlineDevice'><b>Online</b></Col></>)
        } else {
            // Show "Offline" for disconnected, offline, or any other status
            return (
                <><Col span={24} className="card-img" data-testid="imagee-id">
                    <UIImage src={offlineDevice} alt="offlineDevice" height="85px" width="85px" />
                </Col>
                    <Col span={24} className='offlineDevice'><b>Offline</b></Col></>)
        }
    }


    return (
        <Card className='card-content' data-testid="cardd-id" >
            <Row className='card-box'>
                <Col span={24} className='card-heading deviceDetail slice' data-testid="heading-id">{device?.name}</Col>
                <Col xl={24} lg={20} md={15} sm={10} className='deviceDetail slice'>{device?.tenantName} | {device?.deviceSiteZoneProcess[0]?.siteName} | {device?.deviceSiteZoneProcess[0]?.zoneName}</Col>
            </Row>
            <Row className='card-box'>
                {deviceStatusChange()}
            </Row>
        </Card>
    )
}